<template>
  <v-container class="container">
    <v-data-table
      :page.sync="page"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      class="elevation-2"
      dense
      :footer-props="{ disableItemsPerPage: true }"
    >
      <template v-slot:item.libelle="{ item }">
        <router-link :to="{ name: 'deno-commune', params: { id: item.id } }">
          {{ item.libelleDenoPharmat || item.libelle }}

          <span v-if="item.estEquivalence"> ({{ item.libelle }})</span>
        </router-link>
      </template>
      <template v-slot:item.denominationComune="{ item }">
        <router-link
          :to="{ name: 'deno-commune', params: { id: item.idDenoCommune } }"
        >
          {{ item.denominationComune }}
        </router-link>
      </template>
      <template v-slot:item.nom="{ item }">
        <router-link :to="{ name: 'fournisseur', params: { id: item.id } }">
          {{ item.nom }}
          <img
            v-if="item.estAdherant"
            :src="require('@/assets/coccinelle_petite.png')"
            alt="Fournisseur adhérant"
            title="Fournisseur adhérant"
            style="border-width: 0px; width: 15px"
          />
        </router-link>
      </template>
      <template v-slot:item.fournisseur="{ item }">
        <router-link
          :to="{ name: 'fournisseur', params: { id: item.idFournisseur } }"
        >
          {{ item.fournisseur }}
          <img
            v-if="item.fournisseurAdherant"
            :src="require('@/assets/coccinelle_petite.png')"
            alt="Fournisseur partenaire"
            style="border-width: 0px; width: 15px"
            title="Fournisseur partenaire"
          />
        </router-link>
      </template>
      <template v-slot:item.denominationCommerciale="{ item }">
        <span v-if="item.fournisseurAdherant">
          <router-link :to="{ name: 'produit', params: { id: item.id } }">
            {{ item.denominationCommerciale }}
          </router-link>
        </span>
        <span v-else>
          {{ item.denominationCommerciale }}
        </span>
      </template>
      <template v-slot:item.nombreDenosCommunes="{ item }">
        <router-link
          :to="{
            name: 'denos-communes-fournisseur',
            params: { id: item.id },
          }"
        >
          {{ item.nombreDenosCommunes }}
        </router-link>
      </template>
      <template v-slot:item.nombreFournisseurs="{ item }">
        <router-link
          :to="{ name: 'fournisseurs-deno-commune', params: { id: item.id } }"
        >
          {{ item.nombreFournisseurs }}
        </router-link>
      </template>
      <template v-slot:item.nombreProduits="{ item }">
        <router-link
          :to="{
            name: 'produits-' + (item.nom ? 'fournisseur' : 'deno-commune'),
            params: { id: item.id },
          }"
        >
          {{ item.nombreProduits }}
        </router-link>
      </template>
    </v-data-table>
    <div class="legendes">
      <p v-if="[2, 3, 4, 5, 8].includes($store.state.recherche.type)">
        <img
          :src="require('@/assets/coccinelle_petite.png')"
          alt="Coccinelle"
          style="border-width: 0px; width: 15px"
        />: Fournisseur abonné
      </p>
      <p v-if="false && $store.state.recherche.type == 1">
        <v-icon> mdi-approximately-equal </v-icon> Nom d'usage&nbsp;: renvoie à
        une dénomination commune Euro-Pharmat
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "ListeResultats",
  data() {
    return {
      page: 1,
      initialised: false,
    };
  },
  watch: {
    page() {
      if (this.initialised) {
        // console.log("page_change");
        this.$router.push({
          name: this.$route.name,
          query: {
            q: this.$route.query.q,
            page: this.page,
          },
        });
      }
    },
  },
  computed: {
    headers() {
      let widths = [60, 20, 20];
      const denoHeader = {
        text: "DÉNOMINATIONS COMMUNES",
        sortable: false,
        value: "libelle",
        class: "denolighten2",
        cellClass: "denolighten4",
      };
      const denoPdtHeader = {
        text: "DÉNOMINATIONS COMMUNES",
        sortable: false,
        value: "denominationComune",
        class: "denolighten2",
        cellClass: "denolighten4",
      };
      const frnHeader = {
        text: "FOURNISSEURS",
        sortable: false,
        value: "nom",
        class: "fournisseurlighten3",
        cellClass: "fournisseurlighten4",
      };
      const frnPdtHeader = {
        text: "FOURNISSEURS",
        sortable: false,
        value: "fournisseur",
        class: "fournisseurlighten3",
        cellClass: "fournisseurlighten4",
      };
      const pdtHeader = {
        text: "PRODUITS",
        sortable: false,
        value: "denominationCommerciale",
        class: "produitlighten3",
        cellClass: "produitlighten4",
      };
      const denoNbHeader = {
        text: "DÉNOMINATIONS COMMUNES",
        sortable: false,
        align: "center",
        value: "nombreDenosCommunes",
        class: "denolighten2",
        cellClass: "denolighten4",
        info: "",
      };
      const frnNbHeader = {
        text: "FOURNISSEURS",
        align: "center",
        sortable: false,
        class: "fournisseurlighten3",
        value: "nombreFournisseurs",
        cellClass: "fournisseurlighten4",
      };
      const pdtNbHeader = {
        text: "PRODUITS",
        align: "center",
        sortable: false,
        class: "produitlighten3",
        value: "nombreProduits",
        cellClass: "produitlighten4",
      };
      let result;
      switch (this.$store.state.recherche.type) {
        case 2:
          result = [frnHeader, denoNbHeader, pdtNbHeader];
          break;
        case 3:
        case 8:
          result = [pdtHeader, denoPdtHeader, frnPdtHeader];
          widths = [50, 25, 25];
          break;
        case 4:
          result = [frnPdtHeader, pdtHeader];
          widths = [50, 50];
          break;
        case 5:
          result = [pdtHeader, frnPdtHeader];
          widths = [50, 50];
          break;
        case 6:
          result = [denoPdtHeader, pdtHeader];
          widths = [50, 50];
          break;
        case 7:
          result = [pdtHeader, denoPdtHeader];
          widths = [50, 50];
          break;
        default:
          result = [denoHeader, frnNbHeader, pdtNbHeader];
      }
      result.map((v, index) => {
        v.width = `${widths[index]}%`;
        return v;
      });
      return result;
    },
    items() {
      let result = [];
      let storeItems = this.$store.state.recherche.resultats.items;
      result = storeItems;
      return result;
    },
    totalItems() {
      return this.$store.state.recherche.resultats.nbTotal;
    },
  },
  methods: {
    setState(to, from, next) {
      // console.log("setSate", to);
      let page = to.query["page"] || 1;
      switch (to.name) {
        case "home":
          this.$store.dispatch("fetchResultats", {
            recherche: "",
            type: 1,
            page,
          });

          next();
          break;
        case "denos-communes":
          // console.log(to.query);
          this.$store.dispatch("fetchResultats", {
            recherche: to.query["q"],
            type: 1,
            page,
          });
          next();
          break;
        case "fournisseurs-deno-commune":
          this.$store.dispatch("fetchResultats", {
            recherche: to.params.id,
            type: 4,
            page,
          });
          next();
          break;
        case "produits-deno-commune":
          this.$store.dispatch("fetchResultats", {
            recherche: to.params.id,
            type: 5,
            page,
          });
          next();
          break;
        case "fournisseurs":
          // console.log("q:" + to.query["q"]);
          this.$store.dispatch("fetchResultats", {
            recherche: to.query["q"],
            type: 2,
            page,
          });
          next();
          break;
        case "denos-communes-fournisseur":
          this.$store.dispatch("fetchResultats", {
            recherche: to.params.id,
            type: 6,
            page,
          });
          next();
          break;
        case "produits-fournisseur":
          this.$store.dispatch("fetchResultats", {
            recherche: to.params.id,
            type: 7,
            page,
          });
          next();
          break;
        case "produits":
          this.$store.dispatch("fetchResultats", {
            recherche: to.query["q"],
            type: 3,
            page,
          });
          next();
          break;
        case "multiCriteresListe":
          this.$store.dispatch("fetchResultats", {
            recherche: to.params.recherche,
            type: 8,
            page,
          });
          next();
          break;
        default:
          break;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // l'instance du composant est accédé via `vm`
      vm.initialised = false;
      vm.page = parseInt(to.query.page) || 1;
      vm.setState(to, from, next);
      vm.$nextTick().then(() => {
        vm.initialised = true;
      });
    });
    //next();
  },
  beforeRouteUpdate(to, from, next) {
    //console.log("rt_updt");
    if (this.page != parseInt(to.query.page)) {
      this.initialised = false;
      this.page = parseInt(to.query.page) || 1;
      this.setState(to, from, next);
      this.$nextTick().then(() => {
        this.initialised = true;
      });
    }
    this.setState(to, from, next);
  },
};
</script>

<style>
.v-data-table a {
  text-decoration: none;
}
.v-data-table .v-data-table-header tr th {
  font-size: 16px !important;
  color: white !important;
  letter-spacing: 0.1em;
  text-align: center !important;
  font-family: Arial, Helvetica, sans-serif;
}

.v-data-table tr td {
  font-size: 14px !important;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

.v-data-table .denolighten4 a:hover {
  color: #72c3d8;
}

.v-data-table .denolighten4 a {
  color: #325a76;
}

.v-data-table .fournisseurlighten4 a {
  color: #cd8d03;
}
.v-data-table .fournisseurlighten4 a:hover {
  color: #ded866;
}
.v-data-table .produitlighten4 span,
.v-data-table .produitlighten4 a {
  color: #1a7d34;
}
.v-data-table .produitlighten4 a:hover {
  color: #77c786;
}
.v-data-table .v-data-footer__select {
  visibility: hidden;
}
.legendes {
  font-size: 0.75em;
}
</style>
